export default {
    main: {
        a1: 'Operation',
        a2: 'Search',
        a3: 'Reset',
        a4: 'Edit',
        a5: 'Confirm',
        a6: 'Cancel',
        a7: 'Delete',
        a8: 'OK',
        a9: 'Operation successful',
        a10: 'Delete successful',
        b1: 'Collapse sidebar',
        b2: 'WINYI',
        b3: 'Language',
    },
    login:{
        a1: 'WINYI',
        a2: 'Intelligent Integrated Management Platform',
        a3: 'Username*',
        a4: 'Please enter your username',
        a5: 'Password*',
        a6: 'Please enter your password',
        a7: 'Remember password',
        a8: 'Login',
        a9: 'Login successful',
        b1: "System Settings",
        b2: "Reset Password",
        b3: "Logout",
        b4: "Confirm logout?",
        b5: "Password reset successful",
        b6: "Repeat Password",
        b7: "Please repeat the password"
    },
    logs: {
        a1: 'Frontend Version',
        a2: 'Backend Version',
        a3: 'Added role management, menu management, permission allocation, and optimized filtering and sorting functions',
        a4: 'Statistics page reconstruction',
        a5: 'Fixed other known bugs',
        a6: 'Overall system UI modifications',
        a7: 'Unified management of country information, SMS configuration, and email configuration under system settings',
        a8: 'Removed the option to cancel sorting in tables',
        a9: 'Initial development features: homepage statistics, feedback information management, user management, country information management, SMS configuration management, email configuration management',
        a10: 'Shenzhen Lankexuntong Technology Co., Ltd.',
        b1: "Add FAQ module and product information module",
        b2: "Add server ownership statistics",
        b3: "Fix other known bugs"
    },
    dashboard: {
        a1: 'All',
        a2: 'Last Week',
        a3: 'Last 30 Days',
        a4: 'Last 90 Days',
        a5: 'Last Year',
        a6: 'New Users',
        a7: 'Active Users',
        a8: 'New Visitor',
        a9: 'Active Visitors',
        a10: 'User server ownership statistics',
        b1: 'Male',
        b2: 'Female',
        b3: 'Other',
        b4: 'Person',
        b5: 'User Mobile Device Statistics',
        b6: 'Usage Region Distribution',
        b7: 'Registered Users',
        b8: 'Remote Usage',
        b9: 'Unknown',
        b10: 'Total',
        c1: 'Real time Online Users',
        c2: 'Today\'s Cumulative Online',
        c3: 'This Week\'s Cumulative Online',
        c4: 'This Month\'s Cumulative Online',
        c5: 'Device Count',
        c6: 'User-Device Usage Statistics',
        c7: 'Version-based User Distribution',
        c8: 'Application Version User Distribution',
        c9: 'Data',
        c10: 'Graphs',
        c11: 'Region/Country',
        c12: 'User Count',
        c13: 'Remote User Count',
        c14: 'Close',
    },
    user: {
        a1: 'System Users',
        a2: 'APP Registered Users',
        a3: 'APP Visitors',
        a4: 'Please enter your email',
        a5: "Please select the user's mobile system",
        a6: 'New User',
        a7: 'Confirm User Deletion',
        a8: 'Username',
        a9: 'Please enter the username',
        a10: 'User Role',
        b1: 'Please select the user role',
        b2: 'Login Name',
        b3: 'Please enter the login name',
        b4: 'Password',
        b5: 'Please enter the password',
        b6: 'Entering a password while editing will update the password',
        b7: 'Edit User',
        b8: 'Creation Time',
        b9: 'Email',
        b10: 'Gender',
        c1: 'Country',
        c2: 'Phone Model',
        c3: 'Status',
        c4: 'Last Online Time',
        c5: 'Visitor Name',
        c6: 'Click to sort descending',
        c7: 'Online',
        c8: 'Offline',
        c9: 'Register time',
        c10: 'From Server',
        c11: 'System Version',
        c12: 'App Version',
        c13: 'Application',
        c14: 'Please Select Application',
        c15: 'Online Duration (Minutes)',
        c16: 'City/Province',
        c17: 'Mobile Number',
        c18: 'Online Time',
        c19: 'Offline Time',
        c20: 'Online Duration',
        c21: 'Minutes',
        c22: 'Records',
        c23: 'Operations',
        c24: 'Device ',
        d1:'Device List',
        d2:'Yes',
        d3:'No',
        d4:'Custom Name',
        d5:'Model',
        d6:'Electric Quantity',
        d7:'Area',
        d8:'Dealer ',
        d9:'Auto Connection',
        d10:'Firmware Version',
    },
    role: {
        a1: 'Add Role',
        a2: 'Role Name',
        a3: 'Confirm Role Deletion',
        a4: 'Please enter the role name',
        a5: 'Menu Permissions',
        a6: 'Please select menu permissions',
        a7: 'Button Permissions',
        a8: 'Please select button permissions',
        a9: 'Edit Role',
    },
    menu: {
        a1: 'Add Menu',
        a2: 'System Menu',
        a3: 'Add Submenu',
        a4: 'Confirm Menu Deletion',
        a5: 'Function Menu',
        a6: 'Menu Name',
        a7: 'Please enter the menu name',
        a8: 'Menu Route',
        a9: 'Please enter the menu route',
        a10: 'Menu Icon',
        b1: 'Please select a menu icon',
        b2: 'Menu Order',
        b3: 'Please enter the menu order number',
        b4: 'Menu Type',
        b5: 'Please select the menu type',
        b6: 'Add Controllable Button',
        b7: 'Button Name',
        b8: 'Please enter the button name',
        b9: 'Permission Information',
        b10: 'Please enter the permission information',
        c1: 'Controllable buttons already exist in this menu, cannot add submenus',
        c2: 'Edit menu',
    },
    feedback: {
        a1: 'Feedback',
        a2: 'Report',
        a3: 'Unanswered',
        a4: 'Answered',
        a5: 'Failed to Reply',
        a6: 'Are you sure you want to delete this feedback?',
        a7: 'Reply Title',
        a8: 'Please enter the reply title',
        a9: 'Reply Content',
        a10: 'Please enter the reply content',
        b1: 'Reply to Feedback',
        b2: 'Username',
        b3: 'Email',
        b4: 'Location',
        b5: 'Mobile Phone (Version)',
        b6: 'Information',
        b7: 'Type',
        b8: 'Status',
        b9: 'Feedback Time',
        b10: 'More',
    },
    setting: {
        a1: "Country Information Configuration",
        a2: "Email Configuration",
        a3: "SMS Configuration",
        a4: "Add Country",
        a5: "Country Name",
        a6: "Country Dialing Code",
        a7: "Country Identifier",
        a8: "Confirm Delete Country",
        a9: "Country Abbreviation",
        a0: "Please enter the country abbreviation",
        b1: "Please enter the country dialing code",
        b2: "Please enter the country name",
        b3: "Please enter the country identifier",
        b4: "Edit Country",
        b5: "Add Email Configuration",
        b6: "Country",
        b7: "Sender Address",
        b8: "Sender Name",
        b9: "SMTP Server Address",
        b10: "Port",
        c1: "Confirm delete email configuration?",
        c2: "Name",
        c3: "Please enter the sender name",
        c4: "Address",
        c5: "Please enter the sender address",
        c6: "Email SMTP",
        c7: "Please enter the email SMTP server",
        c8: "Authorization Code",
        c9: "Please enter the sender authorization code",
        c10: "SMTP Port",
        d1: "Please enter the SMTP server port",
        d2: "Please select the country identifier",
        d3: "Add Email Configuration",
        d4: "Edit Email Configuration",
        d5: "Add SMS Configuration",
        d6: "Authorization ID",
        d7: "Authorization Key",
        d8: "Signature",
        d9: "SMS Template Code",
        d10: "Confirm delete this SMS configuration?",
        e1: "Please enter the authorization ID",
        e2: "Please enter the SMS template code",
        e3: "Please enter the SMS signature",
        e4: "Please enter the authorization key",
        e5: "Edit SMS Configuration",
        e6: "SMS Signature"
    },
    faq: {
        a1: "search content",
        a2: "Add FAQ",
        a3: "Number",
        a4: "Are you sure you want to delete this FAQ?",
        a5: "Edit FAQ",
        a6: "Add Language",
        a7: "Please enter the question",
        a8: "Please enter the answer",
        a9: "Please add FAQ for at least one language",
        a10: "Please complete the question for {msg}",
        b1: "Please complete the answer for {msg}"
    },
    product: {
        a1: "Please enter the WINYI product model",
        a2: "Please enter the XunTong product model",
        a3: "Please enter the Device type",
        a4: "Please select the main control type",
        a5: "Add Product",
        a6: "None",
        a7: "Are you sure you want to delete this product?",
        a8: "Product Image",
        a9: "WYPID",
        a10: "XunTong Product Model",
        b1: "XTPID",
        b2: "Main Control Type",
        b3: "Edit Product",
        b4: "Product Name",
        b5: "Please enter the product name",
        b6: "Product Description",
        b7: "Please enter the product description",
        b8: "Product Detail Image",
        b9: "View Large Image",
        b10: "Please add product content for at least one language",
        c1: "Please upload a product image",
        c2: "Please complete the product name for {msg}",
        c3: "Please complete the product description for {msg}",
        c4: "Only JPG/PNG files can be uploaded!",
        c5: "The image must be less than 2MB!"
    },
    app:{
        a1:'Apply Name',
        a2:'App Key',
        a3:'Application Icon',
        b1:'Please enter the application name',
        b2:'Please upload the application icon',
        b3:'Please confirm to delete the application',
        c1:'Add Application',
        c2:'Edit Application',
        c3:'Copy Data',
        c4:'Please select the application from which you need to copy the data',
    },
    agreement:{
        a1:'Agreement Title',
        a2:'Agreement Language',
        a3:'Agreement Key',
        a4:'External Access Address',
        a5:'Agreement Type',
        b1:'Please enter the agreement title',
        b2:'Please select the protocol language',
        b3:'Please enter the content of the agreement',
        b4:'Please confirm the deletion of this agreement',
        b5:'Please select the protocol type',
        c1:'New Agreement',
        c2:'Edit Agreement',
        c3:'View Link',
        c4:'User Agreement',
        c5:'Privacy Agreement'

    },
    "登录": "Login",
    "首页": "Home",
    "用户": "User",
    "角色": "Role",
    "菜单": "Menu",
    "版本记录": "Version",
    "总览": "Dashboard",
    "反馈": "Feedback",
    "系统设置": "Settings",
    "产品": "Product",
    "添加产品": "Add Product",
    "编辑产品": "Edit Product",
    "添加FAQ": "Add Faq",
    "编辑FAQ": "Edit Faq",
    "应用": "Apps",
    "协议": "Agreement",
    "APP": "APP",
    "FAQ": "FAQ",

    "DZ": "Algeria",
    "AO": "Angola",
    "BJ": "Benin",
    "BW": "Botswana",
    "BF": "Burkina Faso",
    "BI": "Burundi",
    "CV": "Cape Verde",
    "CM": "Cameroon",
    "CF": "Central African Republic",
    "TD": "Chad",
    "KM": "Comoros",
    "CG": "Congo",
    "CI": "Côte d'Ivoire",
    "DJ": "Djibouti",
    "EG": "Egypt",
    "GQ": "Equatorial Guinea",
    "ER": "Eritrea",
    "ET": "Ethiopia",
    "GA": "Gabon",
    "GM": "Gambia",
    "GH": "Ghana",
    "GN": "Guinea",
    "GW": "Guinea-Bissau",
    "KE": "Kenya",
    "LS": "Lesotho",
    "LR": "Liberia",
    "LY": "Libya",
    "MG": "Madagascar",
    "MW": "Malawi",
    "ML": "Mali",
    "MR": "Mauritania",
    "MU": "Mauritius",
    "MA": "Morocco",
    "MZ": "Mozambique",
    "NA": "Namibia",
    "NE": "Niger",
    "NG": "Nigeria",
    "RW": "Rwanda",
    "ST": "Sao Tome and Principe",
    "SN": "Senegal",
    "SC": "Seychelles",
    "SL": "Sierra Leone",
    "SO": "Somalia",
    "ZA": "South Africa",
    "SS": "South Sudan",
    "SD": "Sudan",
    "TZ": "Tanzania",
    "TG": "Togo",
    "TN": "Tunisia",
    "UG": "Uganda",
    "ZM": "Zambia",
    "ZW": "Zimbabwe",
    "AF": "Afghanistan",
    "AM": "Armenia",
    "AZ": "Azerbaijan",
    "BH": "Bahrain",
    "BD": "Bangladesh",
    "BT": "Bhutan",
    "BN": "Brunei",
    "KH": "Cambodia",
    "CN": "China",
    "CY": "Cyprus",
    "GE": "Georgia",
    "IN": "India",
    "ID": "Indonesia",
    "IR": "Iran",
    "IQ": "Iraq",
    "IL": "Israel",
    "JP": "Japan",
    "JO": "Jordan",
    "KZ": "Kazakhstan",
    "KP": "North Korea",
    "KR": "South Korea",
    "KW": "Kuwait",
    "KG": "Kyrgyzstan",
    "LA": "Laos",
    "LB": "Lebanon",
    "MY": "Malaysia",
    "MV": "Maldives",
    "MN": "Mongolia",
    "MM": "Myanmar",
    "NP": "Nepal",
    "OM": "Oman",
    "PK": "Pakistan",
    "PS": "Palestine",
    "PH": "Philippines",
    "QA": "Qatar",
    "SA": "Saudi Arabia",
    "SG": "Singapore",
    "LK": "Sri Lanka",
    "SY": "Syria",
    "TJ": "Tajikistan",
    "TH": "Thailand",
    "TL": "Timor-Leste",
    "TR": "Turkey",
    "TM": "Turkmenistan",
    "AE": "United Arab Emirates",
    "UZ": "Uzbekistan",
    "VN": "Vietnam",
    "YE": "Yemen",
    "AL": "Albania",
    "AD": "Andorra",
    "AT": "Austria",
    "BY": "Belarus",
    "BE": "Belgium",
    "BA": "Bosnia and Herzegovina",
    "BG": "Bulgaria",
    "HR": "Croatia",
    "CZ": "Czech Republic",
    "DK": "Denmark",
    "EE": "Estonia",
    "FI": "Finland",
    "FR": "France",
    "DE": "Germany",
    "GR": "Greece",
    "HU": "Hungary",
    "IS": "Iceland",
    "IE": "Ireland",
    "IT": "Italy",
    "LV": "Latvia",
    "LT": "Lithuania",
    "LU": "Luxembourg",
    "MK": "Macedonia",
    "MT": "Malta",
    "MD": "Moldova",
    "MC": "Monaco",
    "ME": "Montenegro",
    "NL": "Netherlands",
    "NO": "Norway",
    "PL": "Poland",
    "PT": "Portugal",
    "RO": "Romania",
    "RU": "Russia",
    "SM": "San Marino",
    "RS": "Serbia",
    "SK": "Slovakia",
    "SI": "Slovenia",
    "ES": "Spain",
    "SE": "Sweden",
    "CH": "Switzerland",
    "UA": "Ukraine",
    "GB": "United Kingdom",
    "VA": "Vatican City",
    "AG": "Antigua and Barbuda",
    "AR": "Argentina",
    "BS": "Bahamas",
    "BB": "Barbados",
    "BZ": "Belize",
    "BO": "Bolivia",
    "BR": "Brazil",
    "CL": "Chile",
    "CO": "Colombia",
    "CR": "Costa Rica",
    "CU": "Cuba",
    "DM": "Dominica",
    "DO": "Dominican Republic",
    "EC": "Ecuador",
    "SV": "El Salvador",
    "GD": "Grenada",
    "GT": "Guatemala",
    "GY": "Guyana",
    "HT": "Haiti",
    "HN": "Honduras",
    "JM": "Jamaica",
    "MX": "Mexico",
    "NI": "Nicaragua",
    "PA": "Panama",
    "PY": "Paraguay",
    "PE": "Peru",
    "PR": "Puerto Rico",
    "KN": "Saint Kitts and Nevis",
    "LC": "Saint Lucia",
    "VC": "Saint Vincent and the Grenadines",
    "SR": "Suriname",
    "TT": "Trinidad and Tobago",
    "UY": "Uruguay",
    "VE": "Venezuela",
    "CA": "Canada",
    "US": "United States",
    "GL": "Greenland",
    "AU": "Australia",
    "NZ": "New Zealand",
    "PG": "Papua New Guinea",
    "FJ": "Fiji",
    "SB": "Solomon Islands",
    "VU": "Vanuatu",
    "PW": "Palau",
    "FM": "Federated States of Micronesia",
    "MH": "Marshall Islands",
    "KI": "Kiribati",
    "NR": "Nauru",
    "WS": "Samoa",
    "TO": "Tonga",
    "TV": "Tuvalu",
    "CK": "Cook Islands",
    "NU": "Niue",
    "PF": "French Polynesia",
    "SZ": "Swaziland",
    "LI": "Liechtenstein",
    "EH": "Western Sahara",
    "AS": "American Samoa",
    "BM": "Bermuda",
    "FK": "Falkland Islands",
    "HM": "Heard and McDonald Islands",
    "NC": "New Caledonia",
    "GS": "S. Georgia and S. Sandwich Isls.",
    "1":"unknown",
    "-1":"unknown"
}
